// extracted by mini-css-extract-plugin
module.exports = {"bg":"e_0p","border":"e_1p"};